export const printPassiveIncome = (income) => {
  const printWindow = window.open("", "_blank", "width=900,height=700");
  if (!printWindow) return;

  const companyName = "Habib Gilaman";
  const companyContact = "0767080919 - 0767080919";
  const companyAddress = "Kabul, Afghanistan";
  const formatDate = (dateValue) =>
    dateValue ? new Date(dateValue).toLocaleString() : "-";
  const formatAmount = (value) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(value) || 0);

  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <title>Passive Income Print</title>
        <style>
          * { box-sizing: border-box; }
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 20px;
            color: #1f2937;
            background: #fff;
          }
          .sheet {
            max-width: 210mm;
            margin: 0 auto;
          }
          .header {
            text-align: center;
            border-bottom: 2px solid #0f62fe;
            padding-bottom: 12px;
            margin-bottom: 18px;
          }
          .header h1 {
            margin: 0 0 6px;
            font-size: 24px;
          }
          .header p {
            margin: 2px 0;
            color: #555;
          }
          .info {
            width: 100%;
            border-collapse: collapse;
          }
          .info td {
            border: 1px solid #dbe2ea;
            padding: 10px;
            vertical-align: top;
          }
          .label {
            font-weight: 700;
            width: 28%;
            background: #f8fafc;
          }
          .value {
            width: 72%;
          }
          .footer {
            margin-top: 18px;
            text-align: center;
            color: #6b7280;
            font-size: 12px;
          }
          @media print {
            body { padding: 0; }
          }
        </style>
      </head>
      <body>
        <div class="sheet">
          <div class="header">
            <h1>${companyName}</h1>
            <p>${companyContact}</p>
            <p>${companyAddress}</p>
            <p>Passive Income Receipt</p>
          </div>
          <table class="info">
            <tr><td class="label">ID</td><td class="value">${income?.id || "-"}</td></tr>
            <tr><td class="label">Province Name</td><td class="value">${income?.shop_details?.name || income?.shop_name || "-"}</td></tr>
            <tr><td class="label">Name</td><td class="value">${income?.name || "-"}</td></tr>
            <tr><td class="label">Account</td><td class="value">${income?.account_details?.name || "-"}</td></tr>
            <tr><td class="label">Currency</td><td class="value">${income?.currency_details?.title || "-"}</td></tr>
            <tr><td class="label">Amount</td><td class="value">${formatAmount(income?.amount)} ${income?.currency_details?.title || ""}</td></tr>
            <tr><td class="label">Exchange Rate</td><td class="value">${income?.exchange_rate || "-"}</td></tr>
            <tr><td class="label">Converted Amount</td><td class="value">${formatAmount(income?.converted_amount)} ${income?.account_details?.currency_title || ""}</td></tr>
            <tr><td class="label">Income Date</td><td class="value">${formatDate(income?.income_date)}</td></tr>
            <tr><td class="label">Notes</td><td class="value">${income?.notes || "-"}</td></tr>
          </table>
          <div class="footer">
            Printed on ${new Date().toLocaleString()}
          </div>
        </div>
        <script>
          window.onload = function () {
            window.print();
            window.close();
          };
        </script>
      </body>
    </html>
  `;

  printWindow.document.open();
  printWindow.document.write(html);
  printWindow.document.close();
};

